module.exports = __webpack_public_path__ + "static/media/rasp_goriz.568bddeb.jpg";